import React from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { InfoBadge } from '@hz-design-system/web-ui';

interface ListingUrgencyBadgeProps {}

const ListingUrgencyBadge: React.FC<ListingUrgencyBadgeProps> = () => {
  return (
    <InfoBadge>
      <Trans tagName="span" i18nKey="listings.moet-nu-weg" />
    </InfoBadge>
  );
};

export default ListingUrgencyBadge;
